import { API_JWT_BASE_URL } from '../http'

export const INFRASTRUCTURE_SEARCH_GROUP_API = `${API_JWT_BASE_URL}/infrastructure/group`
export const INFRASTRUCTURE_GET_GROUP_API = `${API_JWT_BASE_URL}/infrastructure/group/`
export const INFRASTRUCTURE_POST_GROUP_API = `${API_JWT_BASE_URL}/infrastructure/group`
export const INFRASTRUCTURE_PUT_GROUP_API = `${API_JWT_BASE_URL}/infrastructure/group/`
export const INFRASTRUCTURE_PUT_GROUP_CONFIGURATION_API = `${API_JWT_BASE_URL}/infrastructure/GroupConfiguration/`
export const INFRASTRUCTURE_GET_GROUPS_WITH_MATCHING_TYPE_API = `${API_JWT_BASE_URL}/infrastructure/group/getgroupswithmatchingtype`

export const INFRASTRUCTURE_DELETE_GROUP_API = `${API_JWT_BASE_URL}/infrastructure/group/`
export const INFRASTRUCTURE_GET_HARDWARE_API = `${API_JWT_BASE_URL}/infrastructure/hardware/`
export const INFRASTRUCTURE_SEARCH_HARDWARE_API = `${API_JWT_BASE_URL}/infrastructure/hardware/`
export const INFRASTRUCTURE_POST_HARDWARE_API = `${API_JWT_BASE_URL}/infrastructure/hardware`
export const INFRASTRUCTURE_PUT_HARDWARE_API = `${API_JWT_BASE_URL}/infrastructure/hardware/`
export const INFRASTRUCTURE_DELETE_HARDWARE_API = `${API_JWT_BASE_URL}/infrastructure/hardware/`
export const INFRASTRUCTURE_BATCH_DELETE_HARDWARE_API = `${API_JWT_BASE_URL}/infrastructure/hardware/batch-delete`
export const INFRASTRUCTURE_MOVE_TO_GROUP_API = `${API_JWT_BASE_URL}/infrastructure/hardware/movetogroup`

export const INFRASTRUCTURE_GET_FIRMWARE_API = `${API_JWT_BASE_URL}/infrastructure/firmware`
export const INFRASTRUCTURE_POST_FIRMWARE_API = `${API_JWT_BASE_URL}/infrastructure/firmware`
export const INFRASTRUCTURE_POST_BULKFIRMWARE_OBSOLETE_API = `${API_JWT_BASE_URL}/infrastructure/firmware/bulkobsolete`
export const INFRASTRUCTURE_POST_BULKFIRMWARE_RESTORE_API = `${API_JWT_BASE_URL}/infrastructure/firmware/bulkrestore`

export const INFRASTRUCTURE_SEARCH_CONFIGURATION_API = `${API_JWT_BASE_URL}/infrastructure/groupconfiguration`
export const INFRASTRUCTURE_GET_CONFIGURATIONS_API = `${API_JWT_BASE_URL}/infrastructure/groupconfiguration/getConfigurations/`
export const INFRASTRUCTURE_GET_CONFIGURATION_API = `${API_JWT_BASE_URL}/infrastructure/groupconfiguration/`
export const INFRASTRUCTURE_PUT_CONFIGURATION_APPROVE_API = `${API_JWT_BASE_URL}/infrastructure/groupconfiguration/approve`
export const INFRASTRUCTURE_POST_CONFIGURATION_DEPLOY_API = `${API_JWT_BASE_URL}/infrastructure/groupconfiguration/deploy`

export const INFRASTRUCTURE_GET_DEPLOYJOBS_API = `${API_JWT_BASE_URL}/infrastructure/groupdeployjob`
export const INFRASTRUCTURE_DONWLOAD_DEPLOYJOBS_PROGRAMMINGLOG_API = `${API_JWT_BASE_URL}/infrastructure/groupdeployjob`

export const INFRASTRUCTURE_GROUP_QUERY_KEYS = {
  INFRASTRUCTURE_SEARCH_GROUP_API: 'INFRASTRUCTURE_SEARCH_GROUP_API',
  INFRASTRUCTURE_GET_GROUP_API: 'INFRASTRUCTURE_GET_GROUP_API',
  INFRASTRUCTURE_DELETE_GROUP_API:'INFRASTRUCTURE_DELETE_GROUP_API',
  INFRASTRUCTURE_GET_GROUPS_WITH_MATCHING_TYPE_API:'INFRASTRUCTURE_GET_GROUPS_WITH_MATCHING_TYPE_API',
}
export const INFRASTRUCTURE_HARDWARE_QUERY_KEYS = {
  INFRASTRUCTURE_GET_HARDWARE_API: 'INFRASTRUCTURE_GET_HARDWARE_API',
  INFRASTRUCTURE_SEARCH_HARDWARE_API: 'INFRASTRUCTURE_SEARCH_HARDWARE_API',
  INFRASTRUCTURE_DELETE_HARDWARE_API: 'INFRASTRUCTURE_DELETE_HARDWARE_API',
  INFRASTRUCTURE_BATCH_DELETE_HARDWARE_API: 'INFRASTRUCTURE_BATCH_DELETE_HARDWARE_API',
  INFRASTRUCTURE_MOVE_TO_GROUP_API:'INFRASTRUCTURE_MOVE_TO_GROUP_API',
}
export const INFRASTRUCTURE_FIRMWARE_QUERY_KEYS = {
  INFRASTRUCTURE_GET_FIRMWARE_API: 'INFRASTRUCTURE_GET_FIRMWARE_API',
}
export const INFRASTRUCTURE_CONFIGURATION_QUERY_KEYS = {
  INFRASTRUCTURE_GET_CONFIGURATION_API: 'INFRASTRUCTURE_GET_CONFIGURATION_API',
  INFRASTRUCTURE_SEARCH_CONFIGURATION_API: 'INFRASTRUCTURE_SEARCH_CONFIGURATION_API',
  INFRASTRUCTURE_GET_CONFIGURATIONS_API: 'INFRASTRUCTURE_GET_CONFIGURATIONS_API',
}

export const INFRASTRUCTURE_DEPLOYJOB_QUERY_KEYS = {
  INFRASTRUCTURE_GET_DEPLOYJOBS_API: 'INFRASTRUCTURE_GET_DEPLOYJOBS_API',
  INFRASTRUCTURE_DONWLOAD_DEPLOYJOBS_PROGRAMMINGLOG: 'INFRASTRUCTURE_DONWLOAD_DEPLOYJOBS_PROGRAMMINGLOG'
}